import { Box, FormControlLabel, Radio, Typography } from "@mui/material";
import { FC } from "react";
import { ICPAnalysisMethod } from "../../../types";
import { ICPProductBasedAnalysisInput } from "./ICPProductBasedAnalysisInput";

interface Props {
  selectedMethod: ICPAnalysisMethod;
  onViewAnalysis: () => void;
}

/**
 * Product-based analysis method option component
 * Displays the product-based analysis option with its input component when selected
 */
export const ICPProductBasedMethodOption: FC<Props> = ({
  selectedMethod,
  onViewAnalysis,
}) => {
  const isSelected = selectedMethod === ICPAnalysisMethod.PRODUCT_BASED;

  return (
    <Box padding={2}>
      <FormControlLabel
        value={ICPAnalysisMethod.PRODUCT_BASED}
        control={<Radio />}
        label={<Typography variant="body1">Product-based Analysis</Typography>}
      />

      <Box marginLeft="31px">
        <Typography variant="body1" color="text.secondary">
          Select your product(s) and we'll automatically identify companies
          where they're installed. We'll analyze these companies to reveal
          common firmographic and technographic patterns among your current
          customers. Ideal if you want a data-driven analysis based on actual
          product usage.
        </Typography>

        {isSelected && (
          <ICPProductBasedAnalysisInput onViewAnalysis={onViewAnalysis} />
        )}
      </Box>
    </Box>
  );
};
